const emitters = {};

export default function TabEmitter(key) {
  key = `tab-emitter:${key || ''}`;
  if (!emitters[key]) emitters[key] = new Emitter(key);
  return emitters[key];
}

window.addEventListener('storage', (ev) => {
  if (ev.newValue && emitters[ev.key]) {
    const args = JSON.parse(ev.newValue);
    emitters[ev.key].__emit(args.key, args.values);
  }
});

class Emitter {
  observes = [];
  key = '';

  constructor(key) {
    this.key = key || '';
  }

  __emit(key, values) {
    this.observes.forEach(item => {
      if (item.key === key) {
        item.fn(...values);
      }
    });
  }

  emit(key, ...arg) {
    window.localStorage.setItem(this.key, JSON.stringify({
      key,
      values: arg || [],
    }));
    window.localStorage.removeItem(this.key);
    this.__emit(key, arg || []);
  }

  on(key, fn) {
    this.observes.push({
      key,
      fn,
    });
    return () => {
      this.observes = this.observes.filter(i => i.fn !== fn);
    };
  }
}
